import { EQ, GT, GTE, LIKE, LT, LTE} from "../framework/query";

export const FilterTypeMap = new Map([
    [GTE, "	≥"],
    [GT, ">"],
    [LTE, "≤"],
    [LT, "<"],
    [EQ, "="],
    [LIKE, "≈"]
])

export const RatingType = {
   ONE_TO_FIVE: "one_to_five",
   ONE_OR_FIVE: "one_or_five",
   TARGET: "target",
   TEXT: "text",
}

export const TargetType = {
    GTE: "gte",
    EQUAL: "equal",
    LTE: "lte",
}

export const ComputationType = {

    NOT_COMPUTED: "not-computed",
    SUM: "sum",
    AVG: "avg",
    MIN: "min",
    MAX: "max",

}